/**
 * Diagnosis Service
 * Patient diagnosis tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DiagnosisTypeResponseDto } from './diagnosisTypeResponseDto';
import { AnnotationDto } from './annotationDto';


export interface DiagnosisResponseDto { 
    /**
     * Diagnosis identifier
     */
    id: string;
    /**
     * Tenant identifier
     */
    tenantId: string;
    /**
     * Collection identifier for diagnosis types
     */
    collectionId: string;
    /**
     * Patient identifier
     */
    patientId: string;
    /**
     * Encounter identifier
     */
    encounterId?: string;
    /**
     * Element identifier from reference data
     */
    elementId: string;
    /**
     * Diagnosis type details (when requested via expand parameter)
     */
    diagnosisType?: DiagnosisTypeResponseDto;
    /**
     * Diagnosis status
     */
    status: DiagnosisResponseDto.StatusEnum;
    /**
     * Clinical status element ID
     */
    clinicalStatus?: string;
    /**
     * Verification status element ID
     */
    verificationStatus?: string;
    /**
     * Severity element ID
     */
    severity?: string;
    /**
     * Body site element IDs
     */
    bodySite?: Array<string>;
    /**
     * Onset date and time
     */
    onsetDateTime?: string;
    /**
     * Abatement date and time
     */
    abatementDateTime?: string;
    /**
     * Date recorded
     */
    recordedDate?: string;
    /**
     * Recorder identifier
     */
    recorder?: string;
    /**
     * Asserter identifier
     */
    asserter?: string;
    /**
     * Stage element ID
     */
    stage?: string;
    /**
     * Reference data metadata
     */
    metadata?: any;
    /**
     * Clinical notes
     */
    note?: Array<AnnotationDto>;
    /**
     * User who created the diagnosis
     */
    createdBy: string;
    /**
     * Creation timestamp
     */
    createdOn: string;
    /**
     * User who last updated the diagnosis
     */
    updatedBy?: string;
    /**
     * Last update timestamp
     */
    updatedOn?: string;
}
export namespace DiagnosisResponseDto {
    export type StatusEnum = 'preliminary' | 'confirmed' | 'differential' | 'ruled_out' | 'resolved';
    export const StatusEnum = {
        Preliminary: 'preliminary' as StatusEnum,
        Confirmed: 'confirmed' as StatusEnum,
        Differential: 'differential' as StatusEnum,
        RuledOut: 'ruled_out' as StatusEnum,
        Resolved: 'resolved' as StatusEnum
    };
}


